(function () {
  function initGallery(root) {
    if (!root || root._dsGallery || typeof Swiper === 'undefined') return;

    var mainEl = root.querySelector('.ds-gallery__main');
    var thumbsEl = root.querySelector('.ds-gallery__thumbs');
    if (!mainEl) return;

    var thumbsSwiper = null;

    if (thumbsEl) {
      var thumbsRow = root.querySelector('.ds-gallery__thumbs-row');

      function syncThumbsEdges(swiper) {
        if (!thumbsRow) return;
        thumbsRow.classList.toggle('ds-gallery__thumbs-row--at-start', swiper.isBeginning);
        thumbsRow.classList.toggle('ds-gallery__thumbs-row--at-end', swiper.isEnd);
      }

      thumbsSwiper = new Swiper(thumbsEl, {
        slidesPerView: 4.5,
        spaceBetween: 10,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        freeMode: true,
        watchOverflow: true,
        mousewheel: { forceToAxis: true },
        navigation: {
          prevEl: root.querySelector('.ds-gallery__thumbs-arrow--prev'),
          nextEl: root.querySelector('.ds-gallery__thumbs-arrow--next')
        },
        breakpoints: {
          1024: { slidesPerView: 5 }
        },
        on: {
          init: syncThumbsEdges,
          slideChange: syncThumbsEdges,
          transitionEnd: syncThumbsEdges,
          resize: syncThumbsEdges
        }
      });
    }

    var mainSwiper = new Swiper(mainEl, {
      loop: true,
      grabCursor: true,
      speed: 300,
      slidesPerView: 1,
      watchOverflow: true,
      mousewheel: { forceToAxis: true },
      navigation: {
        prevEl: root.querySelector('.ds-gallery__arrow--prev'),
        nextEl: root.querySelector('.ds-gallery__arrow--next')
      },
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
      keyboard: { enabled: true },
      a11y: {
        prevSlideMessage: root.dataset.prevLabel || 'Previous image',
        nextSlideMessage: root.dataset.nextLabel || 'Next image'
      }
    });

    root._dsGallery = { main: mainSwiper, thumbs: thumbsSwiper };

    var photoSwipeRoot = document.querySelector('[x-ref="photoSwipeComponent"]');

    function openZoom(slideEl) {
      if (!photoSwipeRoot || !slideEl || slideEl.dataset.zoomable !== 'true') return;
      var index = parseInt(slideEl.dataset.photoswipeIndex, 10);
      if (isNaN(index)) return;
      photoSwipeRoot.dispatchEvent(
        new CustomEvent('shapes:photoswipe:open', { detail: { index: index } })
      );
    }

    mainEl.addEventListener('click', function (event) {
      var slideEl = event.target.closest('.swiper-slide');
      if (slideEl) openZoom(slideEl);
    });

    mainEl.addEventListener('keyup', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var slideEl = event.target.closest('.swiper-slide');
      if (slideEl) {
        event.preventDefault();
        openZoom(slideEl);
      }
    });

    document.addEventListener('theme:variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      var mediaId = variant && variant.featured_media && variant.featured_media.id;
      if (!mediaId) return;

      var slides = mainEl.querySelectorAll('.swiper-slide[data-variant-id="' + variant.id + '"]');
      var targetSlide = slides.length
        ? slides[0]
        : mainEl.querySelector('.swiper-slide[data-media-id="' + mediaId + '"]');
      if (!targetSlide) return;

      var index = parseInt(targetSlide.dataset.swiperSlideIndex, 10);
      if (!isNaN(index)) mainSwiper.slideToLoop(index);
    });
  }

  function initAll() {
    document.querySelectorAll('.ds-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.ds-gallery').forEach(initGallery);
  });
})();
